import '../styles/magnet-studio.css';

export function collapseMagnetNavigation() {
  document.getElementById('m5t-side-nav')?.toggleCollapsed?.(true);
}

// Keep the existing routed editor/session, but give authoring the whole viewport.
// Inert only siblings along its ancestry, so the studio itself stays accessible.
export function mountMagnetStudio(host, { editor = false } = {}) {
  const previousFocus = document.activeElement;
  const hidden = new Map();
  let previousOverflow;
  let active = false;
  const resume = () => {
    if (active) return;
    active = true;
    host.classList.add('mag-studio');
    previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    for (let node = host; node.parentElement && node !== document.body; node = node.parentElement) {
      for (const sibling of node.parentElement.children) {
        if (sibling === node || ['SCRIPT', 'STYLE', 'LINK'].includes(sibling.tagName)) continue;
        hidden.set(sibling, { inert: sibling.inert, opacity: sibling.style.getPropertyValue('opacity'), priority: sibling.style.getPropertyPriority('opacity') });
        sibling.inert = true;
        // Floating dashboard decorations can have a higher z-index than the
        // studio. Inert alone prevents clicks but still lets them cover it.
        sibling.style.setProperty('opacity', '0', 'important');
      }
    }
  };
  const suspend = () => {
    if (!active) return;
    active = false;
    for (const [node, previous] of hidden) {
      node.inert = previous.inert;
      if (previous.opacity) node.style.setProperty('opacity', previous.opacity, previous.priority);
      else node.style.removeProperty('opacity');
    }
    hidden.clear();
    document.body.style.overflow = previousOverflow;
    host.classList.remove('mag-studio');
  };
  if (editor) {
    const head = host.querySelector('.mag-modal__head');
    head.after(host.querySelector('.mag-modal__nav'));
    head.append(host.querySelector('.mag-modal__foot-btns'));
    // The actual canvas is already present throughout editing.
    host.querySelector('[data-x="preview"]')?.setAttribute('hidden', '');
    host.querySelector('.mag-modal__body')?.setAttribute('aria-label', 'Magnet settings');
  }
  resume();
  return { resume, suspend, destroy() { suspend(); if (previousFocus?.isConnected) previousFocus.focus?.(); } };
}
